import { html } from "https://cdn.jsdelivr.net/npm/lit-element@4.1.1/+esm";
import { ShadowDOMElement } from "./fields.js";

export class DirectorContainer extends ShadowDOMElement {
  static className = "DirectorContainer";
  
  render() {
    return html`
      <checkbox-field
        label="Directeur général"
        id-input="chkDirector"
		id="chk-director"
        name="directeur"
        @change="${this.handleCheckboxChange}"
      ></checkbox-field>
      <div-container id="director-container" visible="false">
        <row-wrapper>
          <text-field label="Nombre d'exercices *" required name="number_of_exercises" disable-autocomplete></text-field>
        </row-wrapper>
        <row-wrapper>
          <date-field label="Date de fin d'exercice *" required name="date_exercise"></date-field>
        </row-wrapper>
        <personne-physique></personne-physique>
      </div-container>
    `;
    }

	handleCheckboxChange(event) {
		const directorContainer = this.shadowRoot.querySelector("#director-container");
		if (directorContainer)
			directorContainer.visible = event.target.checked;
	}
	
	isTransient (){
		return false;
	}

	#updateContainers (){
		const visible = this.shadowRoot.querySelector ("#chk-director").checked;
		this.shadowRoot.querySelector ("#director-container").visible = visible;
	}

	setValues (values){
		super.setValues (values);
		this.#updateContainers ();
		this.requestUpdate ();
	}
}

customElements.define("director-container", DirectorContainer);
